import { Grid } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityAboutCard } from '@backstage/plugin-catalog';
import {
  useCustomFieldExtensions,
  ScaffolderFieldExtensions,
  useTemplateSecrets,
} from '@backstage/plugin-scaffolder-react';
import { Workflow } from '@backstage/plugin-scaffolder-react/alpha';
import {
  EntityNamePickerFieldExtension,
  EntityPickerFieldExtension,
  EntityTagsPickerFieldExtension,
  MyGroupsPickerFieldExtension,
  RepoUrlPickerFieldExtension,
} from '@backstage/plugin-scaffolder';
import '@backstage/plugin-scaffolder-react';
import { ae360ScaffolderExtensions } from '@internal/acc-react-shared';
import { alertApiRef, useApi } from '@backstage/core-plugin-api';
import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';
import { useNavigate } from 'react-router-dom';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { entityWarningContent } from './EntityWarningContent';

const extensionSet = (
  <ScaffolderFieldExtensions>
    <EntityPickerFieldExtension />
    <RepoUrlPickerFieldExtension />
    <MyGroupsPickerFieldExtension />
    <EntityTagsPickerFieldExtension />
    <EntityNamePickerFieldExtension />
    {ae360ScaffolderExtensions()}
    <EntityPickerFieldExtension />
  </ScaffolderFieldExtensions>
);

export const UnclaimedOverviewContent = () => {
  const { entity } = useEntity();
  const extensions = useCustomFieldExtensions(extensionSet);
  const { secrets: contextSecrets } = useTemplateSecrets();
  const scaffolderAPI = useApi(scaffolderApiRef);
  const alertApi = useApi(alertApiRef);
  const navigate = useNavigate();
  let templateName = 'claim-repo-azure';

  // Handle different SCM hosts, including variations of GitHub
  const scmHost = entity.metadata.annotations?.['scm.host'] || '';

  if (scmHost.includes('github.com')) {
    templateName = 'claim-repo-github';
  } else if (scmHost.includes('dev.azure.com')) {
    templateName = 'claim-repo-azure';
  } else {
    templateName = 'claim-repo-azure'; // default fallback
  }

  const create = async (values: any) => {
    try {
      const result = await scaffolderAPI.scaffold({
        values: values,
        templateRef: `template:default/${templateName}`,
        secrets: contextSecrets,
      });
      navigate(`/create/tasks/${result.taskId}`);
    } catch (err: any) {
      alertApi.post({
        severity: 'error',
        message: `Failed to schedule scaffold  ${err?.message}`,
      });
    }
  };

  const templateState = {
    unclaimedEntityRef: stringifyEntityRef(entity),
    name: entity.metadata.name,
    repoUrl: {
      allowedOwners: entity.metadata.annotations?.['scm.organization'] || [],
    },
  };

  return (
    <Grid container spacing={3} alignItems="stretch">
      {entityWarningContent}
      <Grid item md={6} data-intercom-target="entity-page-overview">
        <EntityAboutCard variant="gridItem" />
      </Grid>
      <Grid
        item
        md={6}
        xs={12}
        data-intercom-target="entity-page-overview-graph"
      >
        <Workflow
          templateName={templateName}
          initialState={templateState}
          namespace="default"
          onError={(err: any) => <span>Error {err?.message}</span>}
          extensions={extensions}
          onCreate={create}
        />
      </Grid>
    </Grid>
  );
};
